import { Alert, AppBar, Box, Button, ButtonBase, Stack, Toolbar, Typography, styled } from '@mui/material';
import { useNavigate, useParams } from 'react-router';

import Iconify from '../../../components/Iconify';

const CustomAlert = styled(Alert)(({ theme }) => ({
  fontSize: 9,
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  borderRadius: 0,
  padding: '0px 16px',
  position: 'fixed',
  top: 0,
  zIndex: 9,
  width: '100%',
  backgroundColor: '#f5b007',
}));

const DownloadAppAlert = ({ navigate, setShowDownloadApp, translate }) => {
  return (
    <CustomAlert
      icon={<Iconify icon={'line-md:download-loop'} sx={{ color: '#6E2100' }} />}
      variant="filled"
      severity="info"
      sx={{
        '.MuiAlert-message': {
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        },
      }}
    >
      <Box
        onClick={() => {
          navigate('/download');
          window.location.reload();
        }}
        sx={{ flex: 1, display: 'flex', alignItems: 'center' }}
      >
        <p style={{ whiteSpace: 'nowrap', fontSize: 9, color: '#6E2100' }}>{translate('download_message')}</p>
        <ButtonBase
          sx={{
            ml: 1,
            border: 1,
            background: '#fff',
            color: '#6E2100',
            borderRadius: '4px',
            p: '2px 4px',
            fontSize: '9px',
            fontWeight: 600,
          }}
        >
          {translate('download')}
        </ButtonBase>
      </Box>
      <Iconify
        onClick={() => setShowDownloadApp(false)}
        icon={'ic:round-close'}
        sx={{ color: '#6E2100', width: '20px', height: '20px', cursor: 'pointer' }}
      />
    </CustomAlert>
  );
};

export default DownloadAppAlert;
